var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.1609 40.7531L37.0886 28.6808L33.105 32.6644L45.1773 44.7367L49.1609 40.7531Z",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M31.6953 34.0741C30.9206 34.8489 29.6644 34.8489 28.8896 34.0741L15.5578 20.7423C14.7806 19.9651 14.7806 18.7049 15.5578 17.9276L3.68819 6.05859C-1.44167 12.0382 -1.2411 21.0482 4.42062 26.7099L23.1164 45.4139C28.5495 50.8468 37.4489 51.5673 43.7681 46.146L31.6953 34.0741Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.9469 12.5388L8.99584 0.586426L5.01123 4.57104L16.9632 16.5224L20.9469 12.5388Z",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.6371413edad63940c8d012c5add2ccb1.svg";
export { ForwardRef as ReactComponent };